import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIConstants } from '../constants/API.constansts';
import {
  TermsAndConditions,
  TermsAndConditionsRequest,
} from '../models/terms-and-conditions.interface';
import { UserAccessLevel, UserModel } from '../models/user.model';
import { BaseAPIService } from './base-api.service';

@Injectable({
  providedIn: 'root',
})
export class TermsAndConditionsAPIService extends BaseAPIService {
  public getAllTerms(appliesTo?: UserAccessLevel): Observable<TermsAndConditions[]> {
    const endpoint = appliesTo
      ? `${APIConstants.TERMS_AND_CONDITIONS_ENDPOINT}/role/${appliesTo}`
      : APIConstants.TERMS_AND_CONDITIONS_ENDPOINT;
    return this.get<TermsAndConditions[]>(endpoint, false);
  }

  public createTerms(request: TermsAndConditionsRequest): Observable<TermsAndConditions> {
    return this.post<TermsAndConditions>(APIConstants.TERMS_AND_CONDITIONS_ENDPOINT, request, false);
  }

  public bulkCreateTerms(
    requests: TermsAndConditionsRequest[],
  ): Observable<TermsAndConditions[]> {
    return this.post<TermsAndConditions[]>(
      APIConstants.BULK_TERMS_AND_CONDITIONS_ENDPOINT,
      requests,
      false,
    );
  }

  public updateTerms(
    termsId: string,
    request: TermsAndConditionsRequest,
  ): Observable<TermsAndConditions> {
    return this.put<TermsAndConditions>(
      APIConstants.UPDATE_TERMS_AND_CONDITIONS_ENDPOINT(termsId),
      request,
      false,
    );
  }

  public getTermsByUserId(userId: string): Observable<TermsAndConditions[]> {
    return this.get<TermsAndConditions[]>(
      APIConstants.GET_TERMS_AND_CONDITIONS_USER(userId),
      false,
    );
  }

  public acceptTerms(userId: string, termsId: string): Observable<UserModel> {
    return this.put<UserModel>(
      APIConstants.ACCEPT_TERMS_AND_CONDITIONS_ENDPOINT(userId, termsId),
      {},
      false,
    );
  }
}